export default __webpack_public_path__ + "static/media/digital-marketing.e18fa26d.svg";